import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { Invoice } from 'contracts/Invoice';

const { Types, Creators } = createActions(
  {
    request: ['id', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'FETCH_PUBLIC_INVOICE_',
  }
);

export interface FetchPublicInvoiceState {
  data: Invoice | null;
  loading: boolean;
  errorMessage: string | null;
}

export interface FetchPublicInvoiceRequestAction {
  id: number;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: Invoice;
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: FetchPublicInvoiceState = {
  data: null,
  loading: false,
  errorMessage: null,
};

const request = (state: FetchPublicInvoiceState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: FetchPublicInvoiceState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: FetchPublicInvoiceState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: FetchPublicInvoiceState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const fetchPublicInvoice = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const FetchPublicInvoiceTypes = Types;
export const FetchPublicInvoiceActions = Creators;
